<template>
  <div class="halft-width">
    <div class="trigger_status_actions" @mouseleave="is_open = false">
      <span class="status_button" @click="changeDropDownState()" >
        <span class="user-status" :class="[dynamic_status]"></span>

        {{status_name}} <i class="fa fa-caret-down" aria-hidden="true" style="vertical-align: right"></i>
      </span>

      <!-- <span class="button"> -->
      <!-- <i class="fa fa-caret-down" aria-hidden="true" style="vertical-align: baseline"></i> -->
      <!-- </span> -->
      <div class="status_options" :class="{'status-options-open': is_open}">
        <ul>
          <li :class="[active_status]" @click="updateStatus(status_list.active.id)"><span class="user-status mr-1"></span>{{status_list.active.name}}</li>
          <li :class="[on_hold_status]" @click="updateStatus(status_list.on_hold.id)"><span class="user-status on_hold mr-1"></span>{{status_list.on_hold.name}}</li>
          <li :class="[terminated_status]" @click="updateStatus(status_list.terminated.id)"><span class="user-status terminated mr-1"></span>{{status_list.terminated.name}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    user_status: {
      required: true,
      default: "active"
    },
    provider: {
      required: true
    }
  },
  computed: {
    active_status() {
      if (this.user_status == this.status_list.active.id) {
        return "pointer-events-none";
      }
    },
    terminated_status() {
      if (this.user_status == this.status_list.terminated.id) {
        return "pointer-events-none";
      }
    },
    on_hold_status() {
      if (this.user_status == this.status_list.on_hold.id) {
        return "pointer-events-none";
      }
    },
    status_name() {
      let name = ''
      for (const key in this.status_list) {
        if(this.status_list[key].id == this.user_status){
          name = this.status_list[key].name
          break
        }
      }
      return name
    },
    dynamic_status(){
      let class_ = ''
      for (const key in this.status_list) {
        if(this.status_list[key].id == this.user_status){
          class_ = this.status_list[key].class
          break
        }
      }
      return class_
    }
  },
  data: () => {
    return {
      status_list: {
        terminated: {
          name: "TERMINATED",
          class: "terminated",
          id: 3
        },
        active: {
          name: "ACTIVE",
          class: "",
          id: 1
        },
        on_hold: {
          name: "ON HOLD",
          class: "on_hold",
          id: 2
        }
      },
      is_open: false
    };
  },
  watch: {},
  methods: {
    updateStatus(status) {
      this.$emit("updateStatusProvider", status, this.provider);
      this.changeDropDownState()
    },
    changeDropDownState(){
      this.is_open = !this.is_open
    }
  }
};
</script>
<style scoped>
.halft-width {
  /* width: 50%; */
}
.trigger_status_actions {
  position: relative;
}
.status_button {
  text-align: left !important;
  background: #eeee;
  border: 10px;
  padding: 6px;
  font-size: 12px;
  border-radius: 16px;
  font-family: "gilroy", sans-serif;
  font-weight: 300;
  cursor: pointer;
  min-width: 106px;
  display: block;
}

.hidden-content.hc-right-bottom {
  right: 0;
  top: 100%;
}

.hidden-content {
  position: absolute;
  padding: 10px;
  visibility: hidden;
  opacity: 0;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
  width: 200px;
  z-index: 3;
}
.status_options {
  text-align: left !important;
  opacity: 0;
  visibility: hidden;
  font-size: 12px;
  position: absolute;
  transition: all 0.2s;
  -webkit-transition: all 0.4s;
  width: 200px;
  z-index: 3;
}
.trigger_status_actions:hover > .status_options {
  /* visibility: visible;
  opacity: 1;
  z-index: 99999999999999;
  background-color: #fff;
  -webkit-box-shadow: 2px 1px 18px -9px #000000;
  box-shadow: 2px 1px 18px -9px #000000;
  border-radius: 9px;
  height: 100%; */
}
.status-options-open{
  visibility: visible;
  opacity: 1;
  z-index: 99999999999999;
  background-color: #fff;
  /* padding: 10px; */
  /* position: relative; */
  -webkit-box-shadow: 2px 1px 18px -9px #000000;
  box-shadow: 2px 1px 18px -9px #000000;
  border-radius: 9px;
  height: 100%;

}
.user-status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgb(0, 119, 123);
  display: inline-block;
  position: relative;
  top: 6px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}
.status_button > i{
  position: absolute !important;
  right: 8px !important;
}
.terminated {
  background: red;
}
.on_hold {
  background: #dddddd;
}
ul {
  cursor: pointer !important;
  list-style: none;
  background: #f2f2f2;
  padding: 0.8rem 0.3rem;
  width: 100% !important;
  border-radius: 8px;
  align-content: center;
}
li {
  padding: 0.3rem;
}
li:hover {
  opacity: 0.5;
}
.pointer-events-none {
  pointer-events: none;
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/ProviderStatusAction.vue